import { IApiError } from '@frontend/request';

import { accountAPIController } from '@aqx-core/common/api/account';
import { userAccountAPIController } from '@aqx-core/common/api/user-account';
import { mapResponseCodeToMessage } from '@aqx-core/common/request';

import { signUpDemoService } from './service';
import { ESignUpDemoContent, IOpenDemoAccountParams } from './types';

class SignUpDemoViewController {
  public reset = () => {
    signUpDemoService.reset();
  };

  public initSignUpDemo = async (onError: (message: string) => void) => {
    signUpDemoService.setLoading(true);
    try {
      await accountAPIController.getCountryAndDialCodes({
        onError: (error) => {
          const { code, message } = error as IApiError;
          onError(mapResponseCodeToMessage(code, message));
        },
        onSuccess: (res) => {
          res && signUpDemoService.setCountries(res);
        }
      });
      await accountAPIController.getSignUpDepositDefault({
        onError: (error) => {
          const { code, message } = error as IApiError;
          onError(mapResponseCodeToMessage(code, message));
        },
        onSuccess: (res) => {
          res && signUpDemoService.setDefaultDeposit(res);
        }
      });
    } catch (error) {
    } finally {
      signUpDemoService.setLoading(false);
    }
  };

  public openDemoAccount = async ({ params, withAuth = false, onError, onSuccess }: IOpenDemoAccountParams) => {
    signUpDemoService.setLoading(true);
    await (withAuth ? userAccountAPIController.demoSignUpAuthenticated : userAccountAPIController.demoSignUp)(params, {
      onSuccess: (result) => {
        signUpDemoService.setContent(ESignUpDemoContent.COMPLETE);
        if (result) {
          signUpDemoService.setDetails(result);
        }
        onSuccess?.();
      },
      onError: (error) => {
        const { code, message } = error as IApiError;
        onError(mapResponseCodeToMessage(code, message));
      }
    }).finally(() => {
      signUpDemoService.setLoading(false);
    });
  };
}

export const signUpDemoViewController = new SignUpDemoViewController();
